import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNotifications } from '../hooks/useNotifications';

/**
 * Invisible component that bridges SignalR notifications → React Query cache invalidation.
 * Must be rendered inside QueryClientProvider.
 * When an appointment-related notification arrives via SignalR, invalidates the
 * ['appointments'] query key so all consumers (AppointmentsPage etc.) refetch automatically.
 */
export default function QueryInvalidator() {
  const queryClient = useQueryClient();

  const handleNotification = useCallback((notification) => {
    const type = notification?.type ?? notification?.notificationType;
    if (type && type.startsWith('appointment.')) {
      queryClient.invalidateQueries({ queryKey: ['appointments'] });
    }
  }, [queryClient]);

  useNotifications(handleNotification);

  return null;
}
